import { type ReactNode } from 'react';
import { ModalContent, ModalOverlay } from '@hungryroot/ramen';
import styles from './ThresholdModal.module.css';

interface Props {
  testid?: string;
  children: ReactNode;
  ariaLabel: string;
}

export function ThresholdModal(props: Props) {
  const { testid, children, ariaLabel } = props;

  return (
    <div data-testid={testid}>
      <ModalOverlay isOpen={true} className={styles.overlay}>
        <ModalContent
          ariaLabel={ariaLabel}
          className={styles['dialog-content']}
          data-testid={`${testid}-content`}
        >
          {children}
        </ModalContent>
      </ModalOverlay>
    </div>
  );
}
